import { adLogout } from "../actions/adLogin";
import { AuthApi } from "../requests";
import { clearSession } from "../actions/clearSession";
import { store } from "../store";
import { store as uiStore } from "../store/ui";
import * as HelperSrc from "../HelperSrc";
import { lang } from "../lang";

function logout(): void {
    uiStore.setLoaded(false);

    const auth = new AuthApi({
        basePath: uiStore.apiPath
    });

    auth.authLogoutCreate((response) => {
        if (response instanceof Error) {
            return;
        }

        const adInitStatus = localStorage.getItem(`${HelperSrc.LABEL}_ad_init_status`);

        if ((store.isAD && uiStore.activeDirectoryReady) || adInitStatus) {
            adLogout();
        } else {
            uiStore.setLoaded(true);

            clearSession();
        }
    });

    store.doNotice(lang.logoutSuccess, true);
}

export { logout };
